/* tslint:disable */
/* eslint-disable */
/**
 * PokerWise Backoffice User Management
 * API for managing PokerWise backoffice users.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export * from './services/user-controller-api';
